<template>
    <div>
      <!-- 头部 -->
      <Header title="tianqin"></Header>
      <Banner :bgImg="bannerImg" :title="'tianqin'"></Banner>
      <div class="tianqBox">
        <div class="indexYq bannerW indexpromoter">
          <div class="yqBox wow slideInUp">
            <div class="left">
              <p :class="['yqName',lang=='en'?'wd448 font40':'wd600 font60']">{{$t('tianqinpromoter.summary.tit1')}}</p>
              <p :class="['yqDscp',lang=='en'?'wd448':'wd600']">{{$t('tianqinpromoter.summary.tips1[0]')}}</p>
              <p :class="['yqDscp',lang=='en'?'wd448':'wd600']">{{$t('tianqinpromoter.summary.tips2[0]')}}</p>
            </div>
            <div class="right">
              <img src="@/assets/images/tgy.png" alt="">
            </div>
          </div>
        </div>
      </div>
      <!-- 介绍：一站式介入 -->
      <div class="tqDesc">
        <div class="bannerW">
          <ul>
            <li v-for="(key,index) in $t('tianqin.desc')" :key = "index">
              <div class="imgDesc">
                <img :src="tqDescImg[index]" alt="">
              </div>
              <div class="imgText">
                <p :class="'name name'+index">{{key.n}}</p>
                <p :class="'desc desc'+index">{{key.d}}</p>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <!-- 尾部 -->
      <Footer></Footer>
    </div>
  </template>
  
  <script>
    import Header from "../../components/header.vue";
    import Footer from "../../components/footer.vue";
    import silder1 from "@/assets/images/slider.png";
    import Banner from "../../components/banner.vue";
    import bannerImg from  "@/assets/images/bg1.png"
    import prj1 from "@/assets/images/arrow-w@2x.png";
    import b1 from "@/assets/images/b1.png";
    import b2 from "@/assets/images/b2.png";
    import b3 from "@/assets/images/b3.png";
    import b4 from "@/assets/images/b4.png";
    import tqTemp1 from "@/assets/images/tqTemp.png"
    import tqTemp2 from "@/assets/images/xfgg.png"
    import tqTemp3 from "@/assets/images/dl.png"
    import tqTemp4 from "@/assets/images/xxl.png"

    export default {
      name: "tianqin",
      components: {
        Header,
        Footer,
        Banner,
      },
      data(){
        return{
          lang: this.$i18n.locale,
          tqDescImg:[b1,b2,b3,b4],
          bannerImg:bannerImg,
          projectList:[{
            projectName:"天琴",
            projectType:"PC/H5广告平台",
            img:prj1,
          },{
            projectName:"天琴",
            projectType:"PC/H5广告平台",
            img:prj1,
          },{
            projectName:"天琴",
            projectType:"PC/H5广告平台",
            img:prj1,
          }],
          listImg:[
            {
              adr:"javascript:;",
              image:silder1
            },
            {
              adr:"javascript:;",
              image:silder1
            },
            {
              adr:"javascript:;",
              image:silder1
            }
          ],
          tabIndex:0,
          tqTempList:[tqTemp1,tqTemp2,tqTemp3,tqTemp4]
        }
      },
      methods: {
        tabChange(index){
          this.tabIndex = index;
        }
      }
    };
  </script>
  <style lang="scss" scoped>
    /* @import url("../assets/css/common.scss"); */
    @import url("https://fonts.googleapis.com/css?family=Work+Sans:400,700,900");
    $anim-text-offset: 1em;
    .style{
      display: flex;
      flex-direction: row;
      justify-content:space-between;
      padding-left: 98px;
      padding-bottom: 143px;
      margin-top: 50px;
      .styleText{
        p{
          display: flex;
          flex-direction:column;
          span{
            line-height: 84px;
            display:block;
            width: 100%;
            font-size:60px;
            font-family:Microsoft YaHei;
            font-weight:600;
            color:rgba(34,34,34,1);
            text-align: center
          }
          .en{
            font-size:40px;
            line-height:56px;
          }
        }
       ul{
         margin-top: 40px;
         display: flex;
         flex-direction: column;
         align-items: center;
          .active{
            background:linear-gradient(270deg,rgba(1,121,233,1) 0%,rgba(0,182,255,1) 100%);
            box-shadow:0px 4px 20px 0px rgba(0,151,255,0.5);
            color:#fff;
          }
          &:hover li{
            background:rgba(250,250,250,1);
            color: #000;
            box-shadow:none;
          }
         li{
          font-size:20px;
          color:rgba(34,34,34,1);
          text-align:center;
          line-height:70px;
          width:287px;
          height:70px;
          background:rgba(250,250,250,1);
          margin-bottom: 15px;
          &:hover{
              cursor:pointer;
            /* width:287px; */
            /* height:70px; */
            background:linear-gradient(270deg,rgba(1,121,233,1) 0%,rgba(0,182,255,1) 100%);
            box-shadow:0px 4px 20px 0px rgba(0,151,255,0.5);
            color:#fff;
            /* text-align:center; */
            /* line-height:70px; */
          }
         }
        
       }
      }
    }
    .tqDesc{
          width:100%;
          height:170px;
          background:rgba(251,251,251,1);
          .bannerW{
            height:100%;
            display:flex;
            flex-direction:row;
            align-items: center;

          }
          ul{
            width:100%;
            display:flex;
            flex-direction:row;
            justify-content:space-between;
            li{
              display:flex;
              flex-direction:row;
              align-items:flex-start;
          .imgDesc{
              width: 66px;
              height:66px;
          }
          .imgText{
            margin-left: 15px;
            .name{
              font-size:20px;
              font-family:Microsoft YaHei;
              font-weight:600;
              color:rgba(34,34,34,1);
            }
            .name2{
              width: 210px;
            }
            .desc{
              font-size:16px;
              font-family:Microsoft YaHei;
              font-weight:400;
              color:rgba(153,153,153,1);
              margin-top:15px;
            }
            .desc0{
              width: 200px;
            }
            .desc2{
              width: 223px;
            }
            .desc3{
              width: 146px;
            }
          }
        }
      }
    }
  </style>